// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M15.4142 1H3V13.2322C3.89751 12.7644 4.91787 12.5 6 12.5C9.58985 12.5 12.5 15.4101 12.5 19C12.5 20.5085 11.9861 21.897 11.1238 23H21V6.58579L15.4142 1ZM14.5 7.5V3L19 7.5H14.5Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7.04998 14.0879L11.9083 19.0021L7.04999 23.9163L5.62771 22.5102L8.10728 20.0021L0.998047 20.0021L0.998047 18.0021L8.10728 18.0021L5.62771 15.494L7.04998 14.0879Z"}}]};

const FileImportFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'file-import-filled',
    ref,
    icon: element,
  },
));

FileImportFilledIcon.displayName = 'FileImportFilledIcon';

export default FileImportFilledIcon;
